import getStaticFile from '@helpers/bucket';

const NO_THEME_PATH = 'icons/noTheme/tracking';

interface LogoTheme {
  src: string;
  height: number;
  width: number;
}

interface LogoConfig {
  alt: string;
  light: LogoTheme;
  blackFriday: LogoTheme;
  dark: LogoTheme;
}

const createLogo = (name: string, fileName: string): LogoConfig => {
  const themeConfig = {
    src: getStaticFile({ path: NO_THEME_PATH, fileName: `${fileName}.svg` }),
    height: 48,
    width: 48,
  };

  return {
    alt: `Logo da ${name}`,
    light: themeConfig,
    blackFriday: themeConfig,
    dark: themeConfig,
  };
};

export const LogoAmazon = createLogo('Amazon', 'amazon');
export const LogoAmericanas = createLogo('Americanas', 'americanas');
export const LogoCarrefour = createLogo('Carrefour', 'carrefour');
export const LogoCasasBahia = createLogo('CasasBahia', 'casas-bahia');
export const LogoCasaTema = createLogo('CasaTema', 'casatema');
export const LogoCnova = createLogo('Cnova', 'cnova');
export const LogoExtra = createLogo('Extra', 'extra');
export const LogoInter = createLogo('Inter', 'inter');
export const LogoLeroyMerlin = createLogo('LeroyMerlin', 'leroy-merlin');
export const LogoMadeiraMadeira = createLogo('MadeiraMadeira', 'madeiramadeira');
export const LogoMagazineLuiza = createLogo('MagazineLuiza', 'magazine-luiza');
export const LogoMercadoLivre = createLogo('MercadoLivre', 'mercado-livre');
export const LogoNoImage = createLogo('NoImage', 'no-image');
export const LogoPontoFrio = createLogo('PontoFrio', 'ponto-frio');
export const LogoShopee = createLogo('Shopee', 'shopee');
export const LogoShoptime = createLogo('Shoptime', 'shoptime');
export const LogoSubmarino = createLogo('Submarino', 'submarino');
export const LogoWebContinental = createLogo('WebContinental', 'web-continental');
